import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import renderRichText from '../../utils/renderRichText';
import '../style.scss';

const BrainComponent = () => {
  const data = useStaticQuery(graphql`
    {
      substance: contentfulOneOhOne(
        title: { eq: "Substance Use & The Brain" }
      ) {
        drugGraphic {
          file {
            url
          }
          title
        }
        title
        paragraph {
          raw
        }
      }
    }
  `);

  const { substance } = data;

  return (
    <div className="has-background-black">
      <section className="section anchor" id="Substance Use & the Brain">
        <div className="container">
          <div className="content">
            <h2 className="is-size-2 pb-2 has-text-white">{substance.title}</h2>
            <div className="has-text-centered">
              <img
                className="thc-graph"
                src={substance.drugGraphic.file.url}
                alt={substance.drugGraphic.title}
              />
            </div>
            <div className="pt-2 mb-6 has-text-white">
              {renderRichText(JSON.parse(substance.paragraph.raw))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BrainComponent;
